import { useMemo } from 'react';
import styles from './header.module.scss';
import cn from 'classnames';
import { ReactComponent as Hamburger } from '@assets/images/Fireboard/hamburgerFireboard.svg';
import { getFilterModes } from './FilterModes';
import MultiSelect from '@components/common/formElements/MultiSelect/index';
import ToggleButton from '../Common/ToggleButton/index';
import NotificationIcon from '@assets/images/Fireboard/NotificationIcon';
import { convertedDate } from '@utility/fireboardUtil';
import constant from '@components/common/globalization';
import HamHeader from './HamburgerHeader';
import SearchIcon from '../../../../assets/images/Fireboard/Search';
import { ReactComponent as CrossIcon } from '@assets/images/Fireboard/crossIcon.svg';
import { ReactComponent as ErrorOrder } from '@assets/images/Fireboard/errorOrder.svg';
import { goToView } from '../../../../utility/fireboardUtil';
import { useNavigate } from 'react-router-dom';
import { safeJsonParse } from '../../../../utility/helperFunction';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';


const Header = props => {
  const {
    onClickHamburger,
    handleFilterChange,
    filtersState,
    currentMode,
    futureOrdersSummary,
    isfutureOrderScreen,
    setIsfutureOrderScreen,
    setFutureOrdersSummary,
    selectedFutureDate,
    handleDateChange,
    setCurrentMode,
    setIsFlip,
    onClickOfNotifications,
    notificationTableData,
    venueNotificationTableData,
    setSearchFieldValue,
    searchFieldValue,
    currentView,
    errorOrderFlag,
    onclickErrorOrders,
    venueStores,
    tableData,
  } = props;
  const current = currentMode || 'DEFAULT';
  const navigate = useNavigate();
  const deviceGroup = safeJsonParse(
    window.sessionStorage.getItem('deviceInfo'),
    {}
  )?.deviceGroup;
  const isVenueMode = deviceGroup?.startMode === 6;
  const storeInfo = safeJsonParse(window.sessionStorage.getItem('auth'), {});
  const venuesInfo =
    venueStores?.saStoreInfos?.length > 0 ? venueStores : null;
  const showErrorOrder =
    deviceGroup?.fireBoardSettings?.displayErrorOrderWarning;
  function filterFiltersBySettings(filterModes, filterType) {
    const filterTypeMap = {
      0: ['Channel', 'Status', 'Location', 'Employee'],
      1: ['Order Type', 'Status', 'Location', 'Employee'],
      2: ['Revenue Center', 'Status', 'Location', 'Employee'],
    };

    const allowedFilters = filterTypeMap[filterType];
    if (!allowedFilters) {
      return filterModes;
    }

    const allowedFilterNames = new Set(allowedFilters);
    const filteredModes = {};

    for (const [modeName, config] of Object.entries(filterModes)) {
      filteredModes[modeName] = {
        ...config,
        filters: (config.filters || []).filter(f => {
          if (f.name === 'Location' && !isVenueMode) {
            return false;
          }
          return allowedFilterNames.has(f.name);
        }),
      };
    }

    return filteredModes;
  }

  const getNotificationsForVenue = [
    ...venueNotificationTableData,
    ...notificationTableData,
  ];

  const filteredNotifications = useMemo(() => {
    if (isVenueMode) {
      return getNotificationsForVenue?.filter(item =>
        deviceGroup?.fireBoardNotificationFilters?.includes(
          item?.notificationTypeId
        )
      );
    } else {
      return notificationTableData?.filter(item =>
        deviceGroup?.fireBoardNotificationFilters?.includes(
          item?.notificationTypeId
        )
      );
    }
  }, [notificationTableData, deviceGroup]);

  const errorOrdersList = Object.values(tableData).filter(
    check => check?.orders?.[0]?.orderStatusId === 9
  );

  const filterModes = useMemo(
    () =>
      getFilterModes({
        venuesInfo,
        storeInfo,
        deviceGroup,
      }),
    [venuesInfo, storeInfo, deviceGroup]
  );

  const filteredFilterModes = filterFiltersBySettings(
    filterModes,
    deviceGroup?.fireBoardCheckFilterType
  );

  const modeConfig = filteredFilterModes[current];

  const getDaysLeftLabel = dateStr => {
    const today = new Date();
    const targetDate = new Date(dateStr);

    today.setHours(0, 0, 0, 0);
    targetDate.setHours(0, 0, 0, 0);

    const diffTime = targetDate - today;
    const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

    return `+${diffDays}d`;
  };

  const getDayName = dateStr => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
    });
  };

  const seen = new Set();

  const uniqueItems = (futureOrdersSummary || []).filter(item => {
    if (seen.has(item.businessDate)) return false;
    seen.add(item.businessDate);
    return true;
  });
  // Transform the date data
  const dateOptions = (uniqueItems || [])
    .map(item => ({
      label: (
        <>
          <span>{convertedDate(item.businessDate)}</span>{' '}
          <span>{`(${getDayName(item.businessDate)})`}</span>{' '}
          <span className={styles.numberOfDays}>
            {getDaysLeftLabel(item.businessDate)}
          </span>
        </>
      ),
      value: item.businessDate,
    }))
    .sort((a, b) => new Date(a.value) - new Date(b.value));

  const futureDateSelector = () => {
    return (
      <div className={cn(styles.dateDropdown)}>
        <MultiSelect
          options={dateOptions}
          isMulti={true}
          maxToShow={1}
          onChange={selected => {
            handleDateChange(selected);
          }}
          placeholder={FLABEL().HEADER_FUTURE_DATE}
          value={selectedFutureDate}
        />
      </div>
    );
  };

  const onClickBackFromfuture = () => {
    setFutureOrdersSummary(null);
    setCurrentMode('DEFAULT');
    setIsFlip(false);
    goToView(currentView, navigate);
    setIsfutureOrderScreen(false);
  };

  return (
    <>
      {isfutureOrderScreen ? (
        <div className={cn('col-12 px-0 mb-3')}>
          <HamHeader
            filterElement={futureDateSelector}
            label={FLABEL().HEADER_FUTURE_ORDERS}
            onClickback={onClickBackFromfuture}
          />
        </div>
      ) : (
        <div
          className={cn(
            styles.headerContainer,
            'col-12 px-0 d-flex justify-content-between align-items-center'
          )}
        >
          <div
            className={cn(
              'col-12 h-100 d-flex fs-32 fw-500 align-items-center mb-3 position-relative',
              styles.headerColor
            )}
          >
            <div className={cn('d-flex', styles.leftContainer)}>
              <span
                className={cn(
                  'd-flex justify-content-center align-items-center',
                  styles.hamburgerContainer
                )}
                onClick={() => onClickHamburger(true)}
              >
                <Hamburger fill="var(--header-icon-color)" />
              </span>
            </div>
            <div className={cn(styles.filterConatiner)}>
              {(modeConfig?.filters || []).map(
                ({
                  name,
                  lable,
                  options,
                  isMulti,
                  maxToShow,
                  isSearchable,
                }) => {
                  return (
                    <div
                      key={name}
                      className={
                        modeConfig?.filters?.length > 2
                          ? styles.filterDropdown
                          : styles.filterDropdown
                      }
                    >
                      <MultiSelect
                        options={options}
                        isMulti={isMulti}
                        onChange={selected => {
                          handleFilterChange(name, selected);
                        }}
                        placeholder={lable}
                        value={filtersState[name]}
                        maxToShow={maxToShow}
                        isSearchable={isSearchable}
                      />
                    </div>
                  );
                }
              )}
            </div>
            <div className="d-flex position-relative pr-1">
              <input
                type="text"
                value={searchFieldValue}
                onChange={e => setSearchFieldValue(e.target.value)}
                className={cn(styles.searchInput, 'col-12 pl-3 pr-5')}
                placeholder={FLABEL().HEADER_SEARCH}
              />

              {searchFieldValue ? (
                <div
                  className={styles.crossIcon}
                  onClick={() => setSearchFieldValue('')}
                >
                  <CrossIcon />
                </div>
              ) : (
                <div className={styles.searchIcon}>
                  <SearchIcon />
                </div>
              )}
            </div>

            <div className="px-2">
              {(modeConfig?.toggles || []).map(
                ({ name, defaultValue, labels }) => (
                  <div key={name}>
                    <ToggleButton
                      key={name}
                      labels={labels}
                      selected={filtersState[name] ?? defaultValue}
                      onToggle={selected => {
                        handleFilterChange(name, selected);
                      }}
                    />
                  </div>
                )
              )}
            </div>

            <div className={styles.fixedNoti}>
              {showErrorOrder && (
                <span
                  className={cn(
                    'd-flex justify-content-center align-items-center position-relative',
                    styles.notificationIcon,
                    { [styles.blink]: errorOrderFlag }
                  )}
                  onClick={() => onclickErrorOrders()}
                >
                  <div
                    className={cn(
                      'd-flex justify-content-center align-items-center position-absolute',
                      styles.notificationCount
                    )}
                  >
                    {errorOrdersList?.length}
                  </div>
                  <ErrorOrder />
                </span>
              )}

              <span
                className={cn(
                  'd-flex justify-content-center align-items-center position-relative',
                  styles.notificationIcon
                )}
                onClick={() => onClickOfNotifications()}
              >
                <div
                  className={cn(
                    'd-flex justify-content-center align-items-center position-absolute',
                    styles.notificationCount
                  )}
                >
                  {filteredNotifications && filteredNotifications?.length}
                </div>
                <NotificationIcon />
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default Header;
